import React from 'react';
import { Box, Button, Card, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import CloudinaryImage from '../../../DesignSystem/CloudinaryImage';

const LOGO_HEIGHT = 38;

const StyledCard = styled(Card)(({ theme: { breakpoints, spacing } }: any) => ({
  padding: spacing(2, 3),
  display: 'flex',
  alignItems: 'center',
  [breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

const StyledCloudinaryImage = styled(CloudinaryImage)(
  ({ theme: { breakpoints, spacing } }: any) => ({
    marginRight: 'auto',
    [breakpoints.down('sm')]: {
      margin: spacing(2, 0),
    },
  }),
);

function SpaceSponsor({ sponsor }: any) {
  return (
    <StyledCard>
      <Box sx={{ mr: 2 }}>
        <Typography variant="h6" component="span">
          <FormattedMessage id="SPACE.HOME.SPONSOR" />
        </Typography>
      </Box>

      <StyledCloudinaryImage
        publicId={sponsor.brand_logo?.s3_key}
        sx={{ height: LOGO_HEIGHT }}
        alt={`Logo ${sponsor.name}`}
        transformation={`h_${LOGO_HEIGHT},q_auto:low`}
      />

      <Button href={sponsor.shareable_url} variant="outlined" color="primary" size="medium">
        <FormattedMessage id="SPACE.HOME.SEE" />
      </Button>
    </StyledCard>
  );
}

SpaceSponsor.propTypes = {
  sponsor: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
    brand_logo: PropTypes.shape({
      s3_key: PropTypes.string,
    }),
  }).isRequired,
};

export default SpaceSponsor;
